import { atom, selector } from "recoil";
import * as constants from "constants/FnolComponentConstants";

const returnDefaultFnol = () => {
  return [
    {
      componentKey: constants.FNOLCOMPONENT_FNOLCOMPLETE,
      controlType: constants.FNOLCOMPONENT_FNOLCOMPLETE,
      componentOrder: 1,
    },
  ];
};

export const fnolQuestionSetStructureState = atom({
  key: "fnolQuestionSetStructureState",
  default: {
    newQuestionSet: true,
    fnolQuestionSetName: null,
    fnolQuestionSetDescription: null,
    customerId: null,
    fnol: returnDefaultFnol(),
    createdByUserId: "",
  },
});

export const fnolQuestionSetState = selector({
  key: "fnolQuestionSetState",
  get: ({ get }) => {
    const fnolQuestionSet = get(fnolQuestionSetStructureState);
    let obj = [...fnolQuestionSet.fnol];
    obj.sort((a, b) => a.componentOrder - b.componentOrder);
    let newObj = obj.map((componentItem, index) => {
      let newData = { ...componentItem };
      newData.componentOrder = index + 1;
      return newData;
    });
    return newObj;
  },
});

export const fnolComponentSelectedKey = atom({
  key: "fnolComponentKeySelected",
  default: "unknown",
});

export const fnolComponentBeingDragged = atom({
  key: "fnolComponentBeingDragged",
  default: "false",
});
